import { Stack } from '@fluentui/react';
import React from 'react';
import { UserMessage } from '..';
import { BaseState } from '../../machine';
export interface SuccessMessageProps<TState extends BaseState> {
  state: TState;
  // Name of the state for which the success message is being displayed
  parent: string;
}

export const SuccessMessage = <TState extends BaseState>(
  props: SuccessMessageProps<TState>
): JSX.Element => {
  const message = generateSuccessMessage(props.state, props.parent);
  return (
    <Stack horizontalAlign="end" styles={{ root: { marginBottom: '1rem' } }}>
      <UserMessage text={message} />
    </Stack>
  );
};

export const generateSuccessMessage = (state: BaseState, parent: string): string | JSX.Element => {
  const responses = state?.context?.responses;
  const response = responses ? responses[parent] : undefined;

  const messageText = state?.meta[state.value.toString()]?.message;

  let message = 'Thank you for your input';
  if (response?.data.length === 1) {
    const selection = response.data[0].value;
    message = `${selection}`;
  }

  return messageText ?? message;
};
